import { useEffect, useState } from 'react';
import { IDashRegistrationLog, IListItem } from '@nkr/models/index';
import { Button, Col, ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import Switch from "react-switch";

interface IProps {
    data: IDashRegistrationLog,
    actionList: IListItem[],
    onSave: (actionTaken: number, comments: string, isPinned: boolean) => void,
    onCancel: () => void
}

const LogEntry = (props: IProps) => {
    const [actionTaken, setActionTaken] = useState(0);
    const [comments, setComments] = useState('');
    const [isPinned, setIsPinned] = useState(false);

    useEffect(() => {
        if (props.data != null) {
            setActionTaken(props.data.actionTakenId);
            setComments(props.data.comments);
            setIsPinned(props.data.isPinned);
        }
    }, [props.data])


    const buttonLabel = props.data == null ? 'Add' : 'Update';

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>
                {props.data == null ? 'Add Log Entry' : 'Edit Log Entry'}
            </Panel.Heading>
            <Panel.Body>
                {props.data != null && (
                    <>
                        <FormGroup>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>Created</Col>
                            <Col xs={12} lg={9}>
                                <div>{props.data.logDateTimeForDisplay}</div>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>Created By</Col>
                            <Col xs={12} lg={9}>
                                <div>{props.data.createdByFullName}</div>
                            </Col>
                        </FormGroup>

                        {props.data.updateDateTimeForDisplay != '' && (
                            <>
                                <FormGroup>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated</Col>
                                    <Col xs={12} lg={9}>
                                        <div>{props.data.updateDateTimeForDisplay}</div>
                                    </Col>
                                </FormGroup>

                                <FormGroup>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated By</Col>
                                    <Col xs={12} lg={9}>
                                        <div>{props.data.updatedByFullName}</div>
                                    </Col>
                                </FormGroup>
                            </>
                        )}
                    </>
                )}

                <FormGroup>
                    <Col xs={12} lg={3} componentClass={ControlLabel}>Action Taken</Col>
                    <Col xs={12} lg={9}>
                        <FormControl
                            componentClass='select'
                            value={actionTaken}
                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => setActionTaken(parseInt(e.currentTarget.value))}
                        >
                            <option value={0}>- Select Action -</option>
                            {props.actionList.map(item =>
                                <option value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={3} componentClass={ControlLabel}>Comments</Col>
                    <Col xs={12} lg={9}>
                        <FormControl
                            componentClass='textarea'
                            rows={6}
                            style={{ resize: 'both', overflow: 'auto' }}
                            value={comments}
                            onChange={(e: React.FormEvent<FormControl & HTMLTextAreaElement>) => setComments(e.currentTarget.value)}
                        />
                    </Col>
                </FormGroup>
            </Panel.Body>
            <Panel.Footer>
                <div className='text-right' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>


                    <div style={{ marginRight: 'auto' }}>
                        <div style={{ marginRight: '5px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: '5px' }}>Is Pinned</span>
                            <Switch className="react-switch" onChange={setIsPinned} checked={isPinned} aria-labelledby="neat-label" />
                        </div>
                    </div>

                    <div style={{ marginLeft: 'auto', marginRight: '10px' }}>
                        <Button bsStyle='primary' onClick={() => props.onSave(actionTaken, comments, isPinned)}>{buttonLabel}</Button>
                    </div>
                    <div>
                        <Button bsStyle='link' onClick={props.onCancel}>Cancel</Button>
                    </div>
                </div>
            </Panel.Footer>

        </Panel>
    );
}

export default LogEntry;